import { InputText } from 'primereact/inputtext'
import { InputTextarea } from 'primereact/inputtextarea'
import { Button } from 'primereact/button'
import { Toast } from 'primereact/toast'
import { useTranslation } from "gatsby-plugin-react-i18next"
import { useMemo, useRef } from 'react'
import { FormFieldContainer, Form } from './styles'
import useForm from 'utils/hooks/useForm'
import sendFormData from '../../utils/sendFormData'

const FORM_NAME = 'contactForm'

const validateFormFields = (formValues) => {
  const entries = Object.entries(formValues)
  const allFilled = entries.every(([, v]) => Boolean(v))

  return allFilled
}

const ContactForm = () => {
  const { t } = useTranslation()
  const toastRef = useRef()
  const fields = useMemo(() => [
    {
      name: 'email',
      label: t('email'),
      type: 'email',
      component: InputText
    }, {
      name: 'name',
      label: t('yourName'),
      component: InputText
    }, {
      name: 'question',
      label: t('question'),
      component: InputTextarea,
      className: 'p-inputtext-lg'
    }
  ], [t])
  const {
    formValues,
    handleFormChange,
    resetFormValues,
    isSubmitting,
    handleSubmit,
    hasError
  } = useForm(
    fields,
    async (formValues) => {
      try {
        await sendFormData({
          ...formValues,
          'form-name': FORM_NAME
        })
        toastRef.current.show({ severity: 'success', summary: t('contactSuccess'), detail: t('contactSuccessfulSubmission'), life: 6000 })
        resetFormValues()
      } catch (err) {
        toastRef.current.show({ severity: 'error', summary: t('contactFailure'), detail: t('contactFailedSubmission'), life: 6000 })
      }
    },
    validateFormFields
  )

  return (
    <Form onSubmit={handleSubmit} name={FORM_NAME} data-netlify="true">
      <Toast ref={toastRef} position='bottom-right' />
      <input type='hidden' value={FORM_NAME} name='form-name' />
      {fields.map((field) => (
        <FormFieldContainer key={field.name}>
          <span className='p-float-label'>
            <field.component
              name={field.name}
              value={formValues[field.name]}
              onChange={handleFormChange}
              type={field.type}
              className={field.className}
              aria-label={field.name}
            />
            <label htmlFor={field.name}>{field.label}</label>
          </span>
        </FormFieldContainer>
      ))}
      <div>
        <Button type='submit' disabled={isSubmitting || hasError}>{t('submit')}</Button>
      </div>
    </Form>
  )
}

export default ContactForm
